(() => {
  const MIXED_HANDLE = '/products/immobilier-en-suisse-dette-transmission-et-capacite-financiere';
  const OLD_TITLE = 'Immobilier en Suisse — BD, simulateur ou pack';
  const NEW_TITLE = 'Immobilier en Suisse — BD ou pack';
  const SIM_VARIANT_ID = '58516042580342';
  const PACK_VARIANT_ID = '58481000841590';
  const BD_VARIANT_ID = '58481000808822';
  const PACK_IMAGE = 'https://cdn.shopify.com/s/files/1/1009/3707/3014/files/jaquette-pack-immobilier_d83d6f36-8b1f-495d-81ba-d1471c407c4b.png?v=1787404916';
  const PACK_ALT = 'Pack Immobilier FinanceLibre — BD pédagogique et simulateur';

  const onMixedProduct = () => window.location.pathname.includes(MIXED_HANDLE);

  function replaceExactText(root = document.body) {
    if (!root) return;
    const walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT);
    let node;
    while ((node = walker.nextNode())) {
      if (node.nodeValue && node.nodeValue.trim() === OLD_TITLE) {
        node.nodeValue = node.nodeValue.replace(OLD_TITLE, NEW_TITLE);
      }
    }
    root.querySelectorAll('[aria-label]').forEach((element) => {
      const label = element.getAttribute('aria-label');
      if (label && label.includes(OLD_TITLE)) {
        element.setAttribute('aria-label', label.replace(OLD_TITLE, NEW_TITLE));
      }
    });
  }

  function updatePackCartImages() {
    document.querySelectorAll(`[id^="CartItem-${PACK_VARIANT_ID}:"]`).forEach((row) => {
      row.querySelectorAll('img').forEach((image) => {
        image.setAttribute('src', PACK_IMAGE);
        image.removeAttribute('srcset');
        image.setAttribute('alt', PACK_ALT);
      });
    });
  }

  function removeObsoleteDescriptionLines() {
    document.querySelectorAll('.fl-product-immobilier-mixte li').forEach((item) => {
      const text = item.textContent.trim();
      if (
        text.startsWith('Simulateur immobilier seul — CHF 9.90') ||
        text.startsWith('Simulateur seul : instructions privées')
      ) {
        item.remove();
      }
    });
  }

  function hideLegacyVariant() {
    const legacyInput = document.querySelector(`input[data-variant-id="${SIM_VARIANT_ID}"]`);
    if (!legacyInput) return;
    const legacyLabel = legacyInput.closest('label');
    if (legacyLabel) {
      legacyLabel.hidden = true;
      legacyLabel.setAttribute('aria-hidden', 'true');
    }
    if (legacyInput.checked) {
      document.querySelector(`input[data-variant-id="${BD_VARIANT_ID}"]`)?.click();
    }
  }

  function updateProductImage() {
    if (!onMixedProduct()) return;
    const selectedId = document.querySelector('input[data-variant-id]:checked')?.dataset.variantId;
    const showPack = selectedId === PACK_VARIANT_ID;

    document.querySelectorAll('.product-media__image, .sticky-add-to-cart__image-img').forEach((image) => {
      if (!image.dataset.flOriginalSrc) {
        image.dataset.flOriginalSrc = image.getAttribute('src') || '';
        image.dataset.flOriginalSrcset = image.getAttribute('srcset') || '';
        image.dataset.flOriginalAlt = image.getAttribute('alt') || '';
      }

      if (showPack) {
        image.setAttribute('src', PACK_IMAGE);
        image.removeAttribute('srcset');
        image.setAttribute('alt', PACK_ALT);
        image.classList.add('fl-pack-preview-image');
      } else {
        image.setAttribute('src', image.dataset.flOriginalSrc);
        if (image.dataset.flOriginalSrcset) image.setAttribute('srcset', image.dataset.flOriginalSrcset);
        image.setAttribute('alt', image.dataset.flOriginalAlt);
        image.classList.remove('fl-pack-preview-image');
      }
    });
  }

  function applyProductSeparation() {
    replaceExactText();
    updatePackCartImages();
    if (!onMixedProduct()) return;
    removeObsoleteDescriptionLines();
    hideLegacyVariant();
    updateProductImage();
  }

  let scheduled = false;
  const scheduleApply = () => {
    if (scheduled) return;
    scheduled = true;
    window.requestAnimationFrame(() => {
      scheduled = false;
      applyProductSeparation();
    });
  };

  document.addEventListener('change', (event) => {
    if (event.target.matches('input[data-variant-id]')) scheduleApply();
  });

  document.addEventListener('DOMContentLoaded', () => {
    applyProductSeparation();
    new MutationObserver(scheduleApply).observe(document.body, { childList: true, subtree: true });
  });
})();
